import { useRouter } from 'next/router'

export function useProfileState() {
  const router = useRouter()

  return {
    profileTab: router.query.tab?.[0] || '',
  }
}

export function useProfileDispatch() {
  const router = useRouter()

  const actions: { [key: string]: any } = {
    change: (payload: string) => {
      router.push(`/profile/${payload}`, undefined, { shallow: true })
    },
    reset: () => {
      router.push(`/profile`)
    },
  }

  return ({ type, payload }: { type: string; payload?: string }) => {
    if (!actions[type]) {
      throw new Error('useProfileDispatch action type not found')
    }

    actions[type](payload)
  }
}
